import { render, staticRenderFns } from "./AgreementConsents.vue?vue&type=template&id=27966c2c&scoped=true&"
import script from "./AgreementConsents.vue?vue&type=script&lang=js&"
export * from "./AgreementConsents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27966c2c",
  null
  
)

export default component.exports